import router, { useRouter } from "next/router";
import { useState } from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { menuData } from "../../data/PublicMenuData";
import { Color } from "../../theme/Color";
import Button from "../Button/Button";
import Logo from "../Logo";
import ChildMenu from "../Menus/ChildMenu";
import MenuItem from "../Menus/MenuItem";

const StyledHeader = styled(Row)`
  position: absolute;
  width: 100%;
  top: 0;
  padding: 0.3rem;
  margin: 0;
  background: ${Color.White};
`;
const ParentMenuItemWrapper = styled(Row)`
  position: relative;
`;

const PublicHeader = () => {
  const { asPath } = useRouter();

  const primaryMenuData = menuData.filter(
    (menuItem) => menuItem.location === "primary"
  );
  const [showChildMenu, setShowChildMenu] = useState(
    Array(primaryMenuData.length).fill(false)
  );

  const toggleMenu = (key, val) => {
    const arr = showChildMenu;
    arr.fill(false);
    arr[key] = val;
    setShowChildMenu(() => [...arr]);
  };

  let timeout;
  const primaryMenu = primaryMenuData.map((menuItem, key) => {
    if (menuItem.childMenu) {
      return (
        <ParentMenuItemWrapper
          key={key}
          onMouseEnter={() => {
            toggleMenu(key, true);
            clearTimeout(timeout);
          }}
          onMouseLeave={() => {
            timeout = setTimeout(() => {
              toggleMenu(key, false);
              clearTimeout(timeout);
            }, 250);
          }}
        >
          <MenuItem
            title={menuItem.title}
            link={menuItem.link}
            isBold={true}
            isParent={true}
            isActive={asPath.startsWith(menuItem.link) ? true : false}
          />

          {showChildMenu[key] && (
            <ChildMenu
              showMenu={showChildMenu[key]}
              setShowMenu={setShowChildMenu}
            >
              {menuItem.childMenu.map((childMenuItem, index) => {
                return (
                  <MenuItem
                    key={key}
                    title={childMenuItem.title}
                    link={childMenuItem.link}
                    isActive={
                      asPath.endsWith(childMenuItem.link) ? true : false
                    }
                    color={Color.Orange5}
                    isChildMenuItem={true}
                  />
                );
              })}
            </ChildMenu>
          )}
        </ParentMenuItemWrapper>
      );
    } else {
      return (
        <MenuItem
          key={key}
          title={menuItem.title}
          link={menuItem.link}
          isBold={true}
          isActive={menuItem.link === asPath ? true : false}
        />
      );
    }
  });

  return (
    <StyledHeader>
      <Col xs={12} style={{ maxWidth: "1300px", margin: "0px auto" }}>
        <Row middle="xs">
          <Col xs={2}>
            <Row>
              <Logo color="orange" />
            </Row>
          </Col>
          <Col xs={6}>
            <Row>{primaryMenu}</Row>
          </Col>
          <Col xs={4}>
            <Row
              style={{
                gap: "0rem",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              {menuData.map((menuItem, key) => {
                return (
                  menuItem.location === "secondary" &&
                  menuItem.title != "Sign Up" && (
                    <MenuItem
                      key={key}
                      title={menuItem.title}
                      link={menuItem.link}
                      isActive={menuItem.link === asPath ? true : false}
                      margin={
                        menuItem.location === "secondary" ? "0" : "0 1rem 0 0"
                      }
                    />
                  )
                );
              })}
              <Button
                label={"Login"}
                size="small"
                color="secondary"
                onClick={() => {
                  router.push("/login");
                }}
                style={{ margin: "0 0 0 1rem", maxHeight: "40px" }}
              ></Button>
              <Button
                label={"Sign Up"}
                size="small"
                color="primary"
                onClick={() => router.push("/personal/register")}
                style={{ margin: "0 0 0 0.5rem", maxHeight: "40px" }}
              ></Button>
            </Row>
          </Col>
        </Row>
      </Col>
    </StyledHeader>
  );
};

export default PublicHeader;
